/**
 * LLM 이 본문을 마크다운 코드펜스로 감싸 보낸 경우 (e.g. ```html ... ```) 선두/말미
 * 펜스를 제거해 실제 렌더러가 평문 본문을 받도록 한다.
 *
 * lang 이 주어지면 해당 언어의 펜스만 제거 (`\`\`\`html`); 미지정 시 모든 펜스 제거.
 */
export function stripFence(source: string, lang?: string): string {
  const trimmed = source.trim();
  const langGroup = lang ? lang.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '\\w*';
  const opening = new RegExp(`^\`\`\`${langGroup}\\s*\\n?`, 'i');
  const m = trimmed.match(opening);
  if (!m) return source;
  let body = trimmed.slice(m[0].length);
  if (body.endsWith('```')) body = body.slice(0, -3);
  return body.trimEnd();
}

/**
 * 부분적으로 스트리밍 중인 JSON 문자열에서 특정 key 의 string 값을 추출한다.
 * 닫는 `"` 가 아직 안 왔다면 지금까지 디코드된 partial 문자열을 반환.
 *
 * 용도: `system.create_artifact` 툴의 input JSON 이 토큰 단위로 들어오는 동안
 * `content` 를 실시간으로 꺼내 패널에 코드뷰로 보여준다.
 *
 * JSON.parse 와 달리 다음을 허용:
 * - 닫는 `"` 없음 (스트림이 아직 진행 중)
 * - 불완전한 `\u` 이스케이프 → 현 시점까지의 디코드만 반환
 */
export function extractStreamingStringField(json: string, key: string): string | undefined {
  const keyEscaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = json.match(new RegExp(`"${keyEscaped}"\\s*:\\s*"`));
  if (!match || match.index === undefined) return undefined;
  let i = match.index + match[0].length;
  let out = '';
  while (i < json.length) {
    const c = json[i];
    if (c === '\\') {
      const next = json[i + 1];
      if (next === undefined) break;
      if (next === 'n') out += '\n';
      else if (next === 't') out += '\t';
      else if (next === 'r') out += '\r';
      else if (next === '"') out += '"';
      else if (next === '\\') out += '\\';
      else if (next === '/') out += '/';
      else if (next === 'b') out += '\b';
      else if (next === 'f') out += '\f';
      else if (next === 'u') {
        const hex = json.slice(i + 2, i + 6);
        if (hex.length < 4) break;
        const code = Number.parseInt(hex, 16);
        if (Number.isNaN(code)) break;
        out += String.fromCharCode(code);
        i += 6;
        continue;
      } else {
        break;
      }
      i += 2;
    } else if (c === '"') {
      return out;
    } else {
      out += c;
      i++;
    }
  }
  return out;
}
